export { default } from './P5TextImage';
